<template>
  <div class="ip-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-place"></i> Company IP Server</span>
        
      </div>

      <el-row>
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <CreateButton :companyUID="companyUID" @on-submited="getIPData()"/>
          <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
            <el-table-column prop="ip" label="IP" width="180"></el-table-column>
            <el-table-column prop="description" label="Description"></el-table-column>
            <el-table-column label="Actions" width="180">
              <template slot-scope="scope" >
                <EditButton :uid="scope.row.uid" @on-submited="getIPData()"/>
                <DeleteButton :uid="scope.row.uid" @on-submited="getIPData()"/>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getIPCompany } from "@/api/ip-server";
import CreateButton from './create-button'
import EditButton from './edit-button'
import DeleteButton from './delete-button'
export default {
  components:{
    EditButton,
    CreateButton,
    DeleteButton
  },
  props: {
    companyUID: String,
  },
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  methods: {
    getIPData() {
      this.loading = true;
      getIPCompany(this.companyUID).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.tableData = data;
        }
      });
    }
  },
  created() {
    this.getIPData();
  },
};
</script>

<style lang="scss">
.ip-manager-container {
}
</style>